import { DocumentStatus, SalesOrderStatus } from '@synergy/models';
import { getDocumentStatusTranslationId, getPurchaseOrderStatusTranslationId } from '@synergy/utils';

export type StatusListKey = 'inquiries' | 'purchase-orders' | 'invoices' | 'sales-orders' | 'demands';

export interface StatusOptions {
    statuses: string[];
    /** Named the way the status pill of the list names it (#2264). */
    translationIdOf: (status: string) => string;
}

const documentStatus = (status: string): string => getDocumentStatusTranslationId(status as DocumentStatus);

/**
 * The statuses a list can be narrowed to, per kind of document: the ones that
 * kind actually carries, not the whole enum (GF 30.10.2026, #2340). The keys
 * are the list and cockpit tab names.
 */
export const STATUS_OPTIONS: Record<StatusListKey, StatusOptions> = {
    inquiries: {
        statuses: [
            DocumentStatus.Created,
            DocumentStatus.Ongoing,
            DocumentStatus.CompletedWithTransition,
            DocumentStatus.CompletedWithoutTransition,
            // Inquiries closed before the split into with and without a follow-up.
            DocumentStatus.Completed,
        ],
        translationIdOf: documentStatus,
    },
    'purchase-orders': {
        statuses: [
            DocumentStatus.Created,
            DocumentStatus.Completed,
            DocumentStatus.CompletedWithTransition,
            DocumentStatus.CompletedWithoutTransition,
            DocumentStatus.Canceled,
        ],
        translationIdOf: status => getPurchaseOrderStatusTranslationId(status as DocumentStatus),
    },
    invoices: {
        statuses: [DocumentStatus.Created, DocumentStatus.Completed, DocumentStatus.Canceled],
        translationIdOf: documentStatus,
    },
    'sales-orders': {
        statuses: [
            SalesOrderStatus.Created,
            SalesOrderStatus.CartPending,
            SalesOrderStatus.Completed,
            SalesOrderStatus.CompletedWithApproval,
        ],
        translationIdOf: documentStatus,
    },
    demands: {
        statuses: [DocumentStatus.Created, DocumentStatus.Scheduled, DocumentStatus.Ongoing, DocumentStatus.Completed],
        translationIdOf: documentStatus,
    },
};
